import { useMemo } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '@/lib/cn';
import { mobileAdmin } from '@/lib/mobileAdminPaths';
import { useSession } from '@/hooks/useSession';

type Tab = { to: string; label: string; icon: string; end?: boolean; homeTab?: boolean };

export function MobileAdminNav() {
  const { pathname } = useLocation();
  const { capabilities } = useSession();

  const tabs: Tab[] = useMemo(() => {
    const list: Tab[] = [
      { to: mobileAdmin.dashboard, label: '首页', icon: 'fa-solid fa-house', end: true, homeTab: true },
      { to: mobileAdmin.entries, label: '查询', icon: 'fa-solid fa-magnifying-glass', end: true },
    ];
    if (capabilities.manage_users) {
      list.push({ to: mobileAdmin.users, label: '用户', icon: 'fa-solid fa-user-gear', end: true });
    }
    return list;
  }, [capabilities.manage_users]);

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200/80 bg-white/95 shadow-[0_-8px_32px_rgba(15,23,42,0.1)] backdrop-blur-xl"
      style={{ paddingBottom: 'max(0.4rem, env(safe-area-inset-bottom))' }}
      role="navigation"
      aria-label="手机后台主导航"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-around">
        {tabs.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end ?? false}
            className={({ isActive }) => {
              const active = isActive || (item.homeTab === true && pathname === mobileAdmin.register);
              return cn(
                'flex min-h-[3.75rem] min-w-0 flex-1 touch-manipulation flex-col items-center justify-center gap-0.5 px-1 py-1 active:bg-slate-50/90',
                active ? 'text-teal-600' : 'text-slate-500'
              );
            }}
          >
            {({ isActive }) => {
              const active = isActive || (item.homeTab === true && pathname === mobileAdmin.register);
              return (
                <>
                  <span
                    className={cn(
                      'flex h-10 w-10 items-center justify-center rounded-xl transition-colors',
                      active ? 'bg-teal-50' : 'bg-transparent'
                    )}
                  >
                    <i className={cn('text-lg', item.icon, active ? 'text-teal-600' : 'text-slate-500')} aria-hidden />
                  </span>
                  <span className="max-w-full truncate text-xs font-semibold leading-tight">{item.label}</span>
                </>
              );
            }}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
